/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import PropTypes from "prop-types";

import { useSelector } from "react-redux";
import { MenuItem, InputLabel } from "@material-ui/core";

import StyledFormControl from "../common/StyledFormControl";
import StyledSelect from "../common/StyledSelect";
import { isAdministrator } from "../../helpers/goTrackUserUtils";
import types from "../../helpers/types";

const UserTypeFilter = ({ setSelectedUserType, selectedUserType }) => {
  const goTrackUser = useSelector((state) => state.goTrackUser);

  const handleUserTypeChange = (event) => {
    setSelectedUserType(event.target.value);
  };

  return (
    <StyledFormControl variant="outlined" fullWidth={true}>
      <InputLabel id="user-type">User type</InputLabel>
      <StyledSelect
        value={selectedUserType ?? ""}
        label="User type"
        labelId="user-type"
        onChange={handleUserTypeChange}
        data-testid="user-type-select"
        style={{ width: "230px" }}
      >
        {isAdministrator(goTrackUser.goTrackUser.roles) && (
          <MenuItem value={types.goTrackUserRoles.administrator}>
            Admin
          </MenuItem>
        )}
        <MenuItem value={types.goTrackUserRoles.carrier}>Carrier</MenuItem>
        <MenuItem value={types.goTrackUserRoles.shipper}>Shipper</MenuItem>
        <MenuItem value={types.goTrackUserRoles.shipperManager}>
          Shipper Manager
        </MenuItem>
      </StyledSelect>
    </StyledFormControl>
  );
};

UserTypeFilter.propTypes = {
  setSelectedUserType: PropTypes.func.isRequired,
  selectedUserType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default UserTypeFilter;
